// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile__avatar {
  flex: 0 0 auto;
}

.profile__heading-top {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-template-areas:
    "avatar info actions"
    "avatar details details";
  column-gap: var(--spacing-md, 1.25rem);
  row-gap: var(--spacing-sm, 0.75rem);
  align-items: start;
  width: 100%;
}

.profile__name {
color: var(--color-text-heading, #000);
font-size: var(--font-size-xxl, 1.75rem); /* 28px */
font-weight: var(--font-weight-bold, 600);
margin: 0;
padding: 0;
text-indent: 0;
line-height: 1.2;
text-align: left;
transform: translateX(-4px);
}

.profile__info {
  grid-area: info;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  align-items: flex-start;
}

.profile__details {
  grid-area: details;
  color: var(--color-text-secondary, #4A5565);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  display: flex;
  width: 100%;
  align-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: var(--spacing-sm, 0.75rem) 2rem; /* 12px vertical, 32px horizontal */
}

.profile__info > .profile__header-bar {
  margin-left: 0;
  padding-left: 0;
  align-self: stretch;
}

.profile__header-bar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
  width: 100%;
  margin: 0;
  padding: 0;
}

.profile__heading-actions {
  grid-area: actions;
  margin-left: auto;
  align-self: flex-start;
}

.profile__avatar {
  grid-area: avatar;
}

.profile__heading-action-button {
  position: static;
  min-width: 0;
  width: auto;
  max-width: none;
  padding: var(--spacing-xxs, 0.3125rem);
}
.profile__identity {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.4375rem; /* 7px */
  justify-content: flex-start;
  width: 100%;
  flex-wrap: nowrap;
}

.profile__pronouns {
  color: var(--color-text-secondary, #4A5565);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.2;
}

.profile__role-org {
  margin: 0;
  width: 100%;
  white-space: normal;
  color: var(--color-text-subheading, #101828);
  font-size: var(--font-size-base, 1rem);
  font-weight: var(--font-weight-medium, 500);
  line-height: 1.25;
  text-align: left;
}

.profile__meta-row,
.profile__contact-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: flex-start;
  column-gap: 0.25rem; /* 4px */
  row-gap: var(--spacing-xs, 0.5rem);
  align-items: start;
  margin: 0;
  padding: 0;
  width: 100%;
}

.profile__meta-row .profile__item,
.profile__contact-row .profile__item {
  display: flex;
  align-items: center;
  gap: var(--spacing-2xs, 0.625rem);
  min-width: 0;
}

.profile__meta-row .profile__value,
.profile__contact-row .profile__value {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-xxs, 0.3125rem);
  min-width: 0;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.profile__meta-row .profile__value-text,
.profile__contact-row .profile__value-text {
  min-width: 0;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.profile__prefix-icon {
  display: inline-flex;
  align-items: center;
  margin-right: 0.125rem;
}

.profile__detail-icon {
  display: block;
  width: 1rem;
  height: 1rem;
}

.profile__hero {
  width: 140px;
  height: 140px;
  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;
  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);
  background: lightgray 50% / cover no-repeat;
  background-position: 50%;
  object-fit: cover;
  object-position: center;
}

.profile__hero-alt {
  width: 140px;
  height: 140px;
  padding: 0 36.4px; 
  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;
  border: 1.6px dashed #CBD5E1;
  background: #F8FAFC;
  box-sizing: border-box;
}

/* added because the icon wasn't centering on mobile
   due to styles in mashlib */
.profile__hero-alt .profile__hero-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.profile__hero-alt .profile__hero-icon svg {
  display: block;
  width: 100%;
  height: 100%;
}

@media (max-width: 640px) {
  .profile__heading-top {
    grid-template-columns: auto minmax(0, 1fr) auto;
    grid-template-areas:
      "avatar info actions"
      "details details details";
    column-gap: var(--spacing-sm, 0.75rem);
    row-gap: var(--spacing-sm, 0.75rem);
  }

  .profile__name {
    font-size: 1.5rem;
    line-height: 1.15;
  }

  .profile__identity {
    gap: 0.125rem;
  }

  .profile__pronouns {
    font-size: var(--font-size-xs, 0.75rem);
    line-height: 1.1;
    white-space: nowrap;
  }

  .profile__hero,
  .profile__hero-alt {
    width: 112px;
    height: 112px;
  }

  .profile__hero-alt {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .profile__hero-icon {
    display: block;
    margin: 0 auto;
    width: 48px;
    height: 48px;
  }

  .profile__details {
    gap: var(--spacing-xs, 0.5rem);
  }

  .profile__meta-row,
  .profile__contact-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 0.25rem;
  }
}

@container profile-pane (max-width: 640px) {
  .profile__heading-top {
    grid-template-columns: auto minmax(0, 1fr) auto;
    grid-template-areas:
      "avatar info actions"
      "details details details";
    column-gap: var(--spacing-sm, 0.75rem);
    row-gap: var(--spacing-sm, 0.75rem);
  }

  .profile__name {
    font-size: 1.5rem;
    line-height: 1.15;
  }

  .profile__identity {
    gap: 0.125rem;
  }

  .profile__pronouns {
    font-size: var(--font-size-xs, 0.75rem);
    line-height: 1.1;
    white-space: nowrap;
  }

  .profile__hero,
  .profile__hero-alt {
    width: 112px;
    height: 112px;
  }

  .profile__hero-alt {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .profile__hero-icon {
    display: block;
    margin: 0 auto;
    width: 48px;
    height: 48px;
  }

  .profile__details {
    gap: var(--spacing-xs, 0.5rem);
  }

  .profile__meta-row,
  .profile__contact-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 0.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/HeadingSection.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C;;4BAE0B;EAC1B,sCAAsC;EACtC,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;AACb;;AAEA;AACA,sCAAsC;AACtC,wCAAwC,EAAE,SAAS;AACnD,yCAAyC;AACzC,SAAS;AACT,UAAU;AACV,cAAc;AACd,gBAAgB;AAChB,gBAAgB;AAChB,2BAA2B;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,wCAAwC,EAAE,SAAS;EACnD,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,oCAAoC,EAAE,mCAAmC;AAC3E;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc,EAAE,QAAQ;EACxB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC,EAAE,SAAS;EACnD,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,sCAAsC;EACtC,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,2BAA2B;EAC3B,mBAAmB,EAAE,QAAQ;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kDAAkD,EAAE,SAAS;EAC7D,0EAA0E;EAC1E,2CAA2C;EAC3C,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kDAAkD,EAAE,SAAS;EAC7D,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;6BAC6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,+CAA+C;IAC/C;;+BAE2B;IAC3B,sCAAsC;IACtC,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,gDAAgD;IAChD,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,+CAA+C;IAC/C;;+BAE2B;IAC3B,sCAAsC;IACtC,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,gDAAgD;IAChD,mBAAmB;EACrB;AACF","sourcesContent":[".profile__avatar {\n  flex: 0 0 auto;\n}\n\n.profile__heading-top {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  grid-template-areas:\n    \"avatar info actions\"\n    \"avatar details details\";\n  column-gap: var(--spacing-md, 1.25rem);\n  row-gap: var(--spacing-sm, 0.75rem);\n  align-items: start;\n  width: 100%;\n}\n\n.profile__name {\ncolor: var(--color-text-heading, #000);\nfont-size: var(--font-size-xxl, 1.75rem); /* 28px */\nfont-weight: var(--font-weight-bold, 600);\nmargin: 0;\npadding: 0;\ntext-indent: 0;\nline-height: 1.2;\ntext-align: left;\ntransform: translateX(-4px);\n}\n\n.profile__info {\n  grid-area: info;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n  align-items: flex-start;\n}\n\n.profile__details {\n  grid-area: details;\n  color: var(--color-text-secondary, #4A5565);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  display: flex;\n  width: 100%;\n  align-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: var(--spacing-sm, 0.75rem) 2rem; /* 12px vertical, 32px horizontal */\n}\n\n.profile__info > .profile__header-bar {\n  margin-left: 0;\n  padding-left: 0;\n  align-self: stretch;\n}\n\n.profile__header-bar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.125rem;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.profile__heading-actions {\n  grid-area: actions;\n  margin-left: auto;\n  align-self: flex-start;\n}\n\n.profile__avatar {\n  grid-area: avatar;\n}\n\n.profile__heading-action-button {\n  position: static;\n  min-width: 0;\n  width: auto;\n  max-width: none;\n  padding: var(--spacing-xxs, 0.3125rem);\n}\n.profile__identity {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 0.4375rem; /* 7px */\n  justify-content: flex-start;\n  width: 100%;\n  flex-wrap: nowrap;\n}\n\n.profile__pronouns {\n  color: var(--color-text-secondary, #4A5565);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 1.2;\n}\n\n.profile__role-org {\n  margin: 0;\n  width: 100%;\n  white-space: normal;\n  color: var(--color-text-subheading, #101828);\n  font-size: var(--font-size-base, 1rem);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 1.25;\n  text-align: left;\n}\n\n.profile__meta-row,\n.profile__contact-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  justify-content: flex-start;\n  column-gap: 0.25rem; /* 4px */\n  row-gap: var(--spacing-xs, 0.5rem);\n  align-items: start;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.profile__meta-row .profile__item,\n.profile__contact-row .profile__item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2xs, 0.625rem);\n  min-width: 0;\n}\n\n.profile__meta-row .profile__value,\n.profile__contact-row .profile__value {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-xxs, 0.3125rem);\n  min-width: 0;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.profile__meta-row .profile__value-text,\n.profile__contact-row .profile__value-text {\n  min-width: 0;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.profile__prefix-icon {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 0.125rem;\n}\n\n.profile__detail-icon {\n  display: block;\n  width: 1rem;\n  height: 1rem;\n}\n\n.profile__hero {\n  width: 140px;\n  height: 140px;\n  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;\n  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);\n  background: lightgray 50% / cover no-repeat;\n  background-position: 50%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.profile__hero-alt {\n  width: 140px;\n  height: 140px;\n  padding: 0 36.4px; \n  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;\n  border: 1.6px dashed #CBD5E1;\n  background: #F8FAFC;\n  box-sizing: border-box;\n}\n\n/* added because the icon wasn't centering on mobile\n   due to styles in mashlib */\n.profile__hero-alt .profile__hero-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n}\n\n.profile__hero-alt .profile__hero-icon svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n@media (max-width: 640px) {\n  .profile__heading-top {\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"avatar info actions\"\n      \"details details details\";\n    column-gap: var(--spacing-sm, 0.75rem);\n    row-gap: var(--spacing-sm, 0.75rem);\n  }\n\n  .profile__name {\n    font-size: 1.5rem;\n    line-height: 1.15;\n  }\n\n  .profile__identity {\n    gap: 0.125rem;\n  }\n\n  .profile__pronouns {\n    font-size: var(--font-size-xs, 0.75rem);\n    line-height: 1.1;\n    white-space: nowrap;\n  }\n\n  .profile__hero,\n  .profile__hero-alt {\n    width: 112px;\n    height: 112px;\n  }\n\n  .profile__hero-alt {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n  }\n\n  .profile__hero-icon {\n    display: block;\n    margin: 0 auto;\n    width: 48px;\n    height: 48px;\n  }\n\n  .profile__details {\n    gap: var(--spacing-xs, 0.5rem);\n  }\n\n  .profile__meta-row,\n  .profile__contact-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 0.25rem;\n  }\n}\n\n@container profile-pane (max-width: 640px) {\n  .profile__heading-top {\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"avatar info actions\"\n      \"details details details\";\n    column-gap: var(--spacing-sm, 0.75rem);\n    row-gap: var(--spacing-sm, 0.75rem);\n  }\n\n  .profile__name {\n    font-size: 1.5rem;\n    line-height: 1.15;\n  }\n\n  .profile__identity {\n    gap: 0.125rem;\n  }\n\n  .profile__pronouns {\n    font-size: var(--font-size-xs, 0.75rem);\n    line-height: 1.1;\n    white-space: nowrap;\n  }\n\n  .profile__hero,\n  .profile__hero-alt {\n    width: 112px;\n    height: 112px;\n  }\n\n  .profile__hero-alt {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n  }\n\n  .profile__hero-icon {\n    display: block;\n    margin: 0 auto;\n    width: 48px;\n    height: 48px;\n  }\n\n  .profile__details {\n    gap: var(--spacing-xs, 0.5rem);\n  }\n\n  .profile__meta-row,\n  .profile__contact-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 0.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
